import React, { useState } from 'react';
import SmartFormEntryDetails from "./SmartFormEntryDetails";

const FormEntry = ({entry}) => {
    const [openModal, setOpenModal] = useState(false);
    const toggleOpenModal = (e) => {
        e.preventDefault();
        setOpenModal(!openModal);
    }

    return (
        <React.Fragment>
            <div className="m-widget2__item complete__form">
                <div className="m-widget2__desc">
                    <a onClick={toggleOpenModal} className="image-popup-container" href="#!" style={{fontSize:'14px',color:'var(--light-gray)'}}>
                        {entry.title} <i className="fa fa-wpforms"/><br/>
                        <p className="text-dark" >{entry.createdAt}</p>
                    </a>
                </div>
            </div>
            {
                openModal && (
                    <SmartFormEntryDetails
                        entry={entry}
                        open={openModal}
                        closeModal={() => setOpenModal(false)}
                    />
                )
            }
        </React.Fragment>
    )
}

export default FormEntry;
